module.exports = __webpack_public_path__ + "img/icon_notification_yezza_normal.689c7615.svg";